export class Promo {
    backgroundImage?: string;
    mobileBackgroundImage?: string;
    // Mobile - Top && Destkop - Left
    firstBlock?: any;
    // Mobile - Bottom && Destkop - Right
    secondBlock?: any;
    weight?: string;
    locationId: string | string[];

    constructor(promo: Partial<Promo>) {
        this.backgroundImage = promo?.backgroundImage ?? '';
        this.mobileBackgroundImage = promo?.mobileBackgroundImage ?? '';
        this.firstBlock = promo?.firstBlock ?? {};
        this.secondBlock = promo?.secondBlock ?? {};
        this.weight = promo?.weight ?? '99';
        this.locationId = typeof promo.locationId == 'string' ? [promo.locationId] : promo.locationId ?? [];
    }

    cdnImg(isPortraitOrientation: boolean): string {
        const url = isPortraitOrientation && this.mobileBackgroundImage != '' ? this.mobileBackgroundImage : this.backgroundImage;
        return this.backgroundImage != '' ? process.env.VUE_APP_IMAGE_URL + '/' + url : '';
    }
}
